import { MODULE_CATEGORIES, getModuleCategory } from '../../Data/enums/homeModuleCategories'

export const FAVORITES_KEY = 'favorites'

// Ignora maiuscole e accenti ("contabilita" trova "Contabilità")
const norm = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

// Filtra per testo (titolo tradotto o originale) e raggruppa: preferiti in cima
// (duplicati, restano anche nella loro categoria) + categorie non vuote.
// Con ricerca attiva tutti i gruppi sono aperti, altrimenti chiusi quelli in closedGroups.
export function buildSidebarGroups (sezioni, { favorites = [], term = '', translate = title => title, closedGroups = [] } = {}) {
  const needle = norm(term.trim())
  const visible = needle === ''
    ? sezioni
    : sezioni.filter(s => norm(translate(s.title)).includes(needle) || norm(s.title).includes(needle))
  const isOpen = key => needle !== '' || !closedGroups.includes(key)

  return {
    favoriteItems: visible.filter(s => favorites.includes(s._id)),
    favoritesOpen: isOpen(FAVORITES_KEY),
    groups: MODULE_CATEGORIES
      .map(category => ({ category, items: visible.filter(s => getModuleCategory(s.title) === category.key), open: isOpen(category.key) }))
      .filter(group => group.items.length > 0)
  }
}

export function toggleClosedGroup (closedGroups, key) {
  return closedGroups.includes(key) ? closedGroups.filter(k => k !== key) : [...closedGroups, key]
}
